import { useState } from 'react';

const BASE_URL = 'https://newtonflaskserver-hfgkcrewf4fgedc6.westus-01.azurewebsites.net';

function CrmSyncTab() {
  const [syncing, setSyncing] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState('');

  const getAuthHeaders = () => {
    const token = localStorage.getItem('jwtToken');
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
    };
  };

  const startSync = async () => {
    setSyncing(true);
    setError(null);
    setTaskId(null);

    const payload = {
      limit: limit ? parseInt(limit, 10) : null,
    };

    try {
      const response = await fetch(`${BASE_URL}/api/crm/sync-attio-to-aircall`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      
      if (data.success) {
        setTaskId(data.task_id);
      } else {
        throw new Error(data.error || 'Failed to queue task');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="tab-content" style={{ padding: '20px' }}>
      <h2>CRM Contact Sync</h2>
      <p style={{ color: '#666', marginBottom: '20px' }}>
        Sync contacts from Attio CRM to Aircall. This will fetch all people with phone numbers 
        from Attio and create/update them as contacts in Aircall.
      </p>

      <div style={{
        background: '#fff8e6',
        border: '1px solid #ffe0a6',
        borderRadius: '6px',
        padding: '12px 16px',
        marginBottom: '20px',
        maxWidth: '600px',
      }}>
        <strong style={{ color: '#8a6d3b' }}>⏱ Note: This task takes time due to Aircall API rate limits</strong>
        <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px', color: '#8a6d3b', fontSize: '13px' }}>
          <li>~2 seconds per contact (to avoid rate limiting)</li>
          <li>~2,000 contacts = ~66 minutes</li>
          <li>The task runs in the background - you can close this page</li>
          <li>Scheduled to run automatically at 6:00 AM PT on weekdays</li>
        </ul>
      </div>

      <div style={{ 
        background: '#f8f9fa', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px',
        maxWidth: '500px'
      }}>
        <h3 style={{ marginTop: 0 }}>Sync Options</h3>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px' }}>
            Limit (optional)
            <span style={{ color: '#888', fontSize: '12px', marginLeft: '8px' }}>
              Max contacts to sync
            </span>
          </label>
          <input
            type="number"
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
            placeholder="No limit"
            style={{
              padding: '8px 12px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              width: '150px',
            }}
          />
        </div>

        <button
          onClick={startSync}
          disabled={syncing}
          style={{
            background: syncing ? '#ccc' : '#1E6434',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '6px',
            cursor: syncing ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: '500',
          }}
        >
          {syncing ? 'Queuing...' : 'Start Sync'}
        </button>
      </div>

      {error && (
        <div style={{
          background: '#fee',
          border: '1px solid #fcc',
          color: '#c00',
          padding: '12px 16px',
          borderRadius: '6px',
          marginBottom: '20px',
          maxWidth: '500px',
        }}>
          {error}
        </div>
      )}

      {taskId && (
        <div style={{
          background: '#e8f5e9',
          border: '1px solid #a5d6a7',
          color: '#2e7d32',
          padding: '12px 16px',
          borderRadius: '6px',
          marginBottom: '20px',
          maxWidth: '500px',
        }}>
          <strong>✓ Sync task queued successfully!</strong>
          <div style={{ marginTop: '8px', fontSize: '13px', color: '#555' }}>
            Task ID: <code style={{ background: '#f5f5f5', padding: '2px 6px', borderRadius: '3px' }}>{taskId}</code>
          </div>
          <div style={{ marginTop: '6px', fontSize: '13px', color: '#666' }}>
            The sync is running in the background. Check Azure logs for progress.
          </div>
        </div>
      )}
    </div>
  );
}

export default CrmSyncTab;
